import { Component } from '@angular/core';

@Component({
  selector: 'fgb-quiz-layout',
  templateUrl: './quiz-layout.component.html',
  styleUrl: './quiz-layout.component.scss',
})
export class QuizLayoutComponent {}
